import React from 'react';
import { FaSave } from 'react-icons/fa';

export default function SaveButton({
    isSubmitting = false,
    children = 'Salvar',
    loadingText = 'Salvando...',
    className = 'btn btn-primary me-1 mb-1',
    type = 'submit',
    disabled = false,
    iconSize = 20,
    ...props
}) {
    return (
        <button type={type} className={className} disabled={disabled || isSubmitting} {...props}>
            {isSubmitting ? (
                <>
                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                    {loadingText}
                </>
            ) : (
                <>
                    <FaSave size={iconSize} /> {children}
                </>
            )}
        </button>
    );
}
